﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadDynamicDrawingAnnotationField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadDynamicDrawingAnnotationField, eOutputFieldType.cadDynamicDrawingAnnotation)
export class CadDynamicDrawingAnnotationField extends OutputField implements ICadDynamicDrawingAnnotationField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public value: string;
    public pointFullName: string;
    public x: number;
    public y: number;
    public viewFullName: string;
}
